import React from "react";
import { Link } from "react-router-dom";
import { BackButton } from "../../components/BackButton";

export default function CGV() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12" data-testid="page-cgv">
      <BackButton to="/" label="Retour" />
      <div className="overline text-accent">— Légal</div>
      <h1 className="font-display font-bold text-4xl tracking-tighter mb-2">Conditions Générales de Vente</h1>
      <p className="text-sm text-amber-700 font-mono mb-8">Projet v2.0 — non en vigueur — à valider par l’avocat avant publication</p>

      <h2 className="font-display font-bold text-xl mt-8 mb-2">1. Prix et grille tarifaire (A–F)</h2>
      <p className="mb-4">
        Les prix sont exprimés en euros. La classe de véhicule est déterminée par le <strong>poids
        et le volume</strong> selon la grille MML à 6 classes (A à F). La grille (Annexe C) est
        <strong> indicative</strong> : l'expéditeur fixe librement son prix. Des suppléments peuvent
        s'appliquer (nuit, samedi, dimanche/férié, attente au-delà de 30 min, péages, approche et
        retour à vide), <strong>sans cumul</strong> (la majoration la plus élevée est retenue). Une
        facture est émise à la livraison. Le régime de TVA dépend du prestataire.
      </p>

      <h2 className="font-display font-bold text-xl mt-8 mb-2">2. Formation du contrat et paiement</h2>
      <p className="mb-4">
        Les transporteurs <strong>candidatent</strong> ; l'expéditeur <strong>choisit</strong> un
        candidat. Le contrat est formé à ce choix. Le paiement s'effectue via <strong>Stripe</strong>
        au moment de la <strong>confirmation du transporteur choisi</strong> (et non à la candidature).
        Stripe traite le paiement ; le reversement au transporteur est bloqué jusqu'à la preuve de livraison
        et la confirmation prévue au parcours. MML n'est pas présenté comme un établissement de crédit ni comme
        détenteur direct des fonds.
      </p>

      <h2 className="font-display font-bold text-xl mt-8 mb-2">3. Reversement au transporteur</h2>
      <p className="mb-4">
        Après <strong>vérification de la livraison</strong>, MML reverse au transporteur <strong>85 %</strong>
        du montant payé (commission MML : 15 % TTC ; frais de paiement à la charge de MML), sur le compte
        bancaire renseigné directement auprès de Stripe Connect.
      </p>

      <h2 className="font-display font-bold text-xl mt-8 mb-2">4. Annulation et remboursement (Annexe H)</h2>
      <ul className="list-disc list-inside mb-4 space-y-2">
        <li>Avant confirmation : aucun frais.</li>
        <li>Après confirmation et ≥ 24 h avant l'enlèvement : annulation gratuite, remboursement du prix.</li>
        <li>À moins de 24 h ou après départ documenté : dossier d'indemnité pour le préjudice justifié (pas de prélèvement automatique du prix intégral).</li>
        <li>MML renonce à sa commission sur les missions annulées avant l'enlèvement.</li>
      </ul>

      <h2 className="font-display font-bold text-xl mt-8 mb-2">5. Périmètre et exclusions</h2>
      <p className="mb-4">
        France métropolitaine hors Corse. Limites par envoi : 6 000 kg, 40 m³, valeur ≤ 10 000 €.
        Sont exclus notamment les animaux vivants, matières dangereuses, marchandises sous température
        dirigée, déchets réglementés et médicaments à contraintes. Les déménagements complets sont
        acceptés dans ces limites.
      </p>

      <h2 className="font-display font-bold text-xl mt-8 mb-2">6. Garantie et responsabilité</h2>
      <p className="mb-4">
        Le transporteur souscrit ses assurances (RC professionnelle, marchandises, véhicule). En cas de
        dommage, le règlement intervient dans le cadre du <Link to="/legal/contrat-transport" className="text-[#1F4032] underline">contrat de transport</Link>,
        avec assistance possible de MML. Les délais légaux de réclamation s'appliquent (L133-3, L224-65).
      </p>

      <h2 className="font-display font-bold text-xl mt-8 mb-2">7. Droit de rétractation</h2>
      <p className="mb-4">
        Conformément à l'article L221-28, 12° du Code de la consommation, le droit de rétractation ne
        s'applique pas aux prestations de transport de biens à une date déterminée. Le rôle
        d'intermédiation de MML est distinct et précisé dans les <Link to="/legal/intermediation" className="text-[#1F4032] underline">clauses d'intermédiation</Link>.
      </p>

      <p className="text-xs text-muted-foreground mt-12">Document indicatif — à valider par un conseil juridique.</p>
    </div>
  );
}
